{
  "login": {
    "title": "Welcome to space ",
    "username": {
      "label": "Username",
      "placeholder": "johndoe"
    },
    "password": {
      "label": "Password",
      "placeholder": "Please insert your password"
    },
    "remember_me": "Remember me",
    "forgot_password": "Forgot your password ?",
    "button": "Connection"
  }
}
